import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "dialog-card" }
const _hoisted_2 = { class: "dialog-title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-question-circle" }, null, -1)
const _hoisted_4 = { class: "dialog-body support-request-container" }
const _hoisted_5 = {
  key: 0,
  class: "dialog-error-message"
}
const _hoisted_6 = { class: "dialog-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_text_field = _resolveComponent("imdex-text-field")!
  const _component_imdex_textarea = _resolveComponent("imdex-textarea")!
  const _component_imdex_btn = _resolveComponent("imdex-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.$t(`supportRequest.title`)), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_imdex_text_field, {
        style: {"margin-bottom":"15px"},
        ref: "name",
        disabled: _ctx.submittingSupportRequest,
        label: _ctx.$t(`supportRequest.nameInputLabel`),
        value: _ctx.request.name,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.request.name) = $event)),
        readonly: _ctx.isUserLoggedIn && _ctx.readonly.name
      }, null, 8, ["disabled", "label", "value", "readonly"]),
      _createVNode(_component_imdex_text_field, {
        style: {"margin-bottom":"15px"},
        ref: "email",
        disabled: _ctx.submittingSupportRequest,
        label: _ctx.$t(`supportRequest.emailInputLabel`),
        value: _ctx.request.email,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.request.email) = $event)),
        type: "email",
        readonly: _ctx.isUserLoggedIn && _ctx.readonly.email
      }, null, 8, ["disabled", "label", "value", "readonly"]),
      _createVNode(_component_imdex_text_field, {
        style: {"margin-bottom":"15px"},
        ref: "company",
        disabled: _ctx.submittingSupportRequest,
        label: _ctx.$t(`supportRequest.companyInputLabel`),
        value: _ctx.request.company,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.request.company) = $event)),
        readonly: _ctx.isUserLoggedIn && _ctx.readonly.company
      }, null, 8, ["disabled", "label", "value", "readonly"]),
      _createVNode(_component_imdex_text_field, {
        style: {"margin-bottom":"15px"},
        ref: "tenant",
        disabled: _ctx.submittingSupportRequest,
        label: _ctx.$t(`supportRequest.tenantInputLabel`),
        value: _ctx.request.tenant,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.request.tenant) = $event)),
        readonly: _ctx.isUserLoggedIn && _ctx.readonly.tenant
      }, null, 8, ["disabled", "label", "value", "readonly"]),
      _createVNode(_component_imdex_text_field, {
        style: {"margin-bottom":"15px"},
        ref: "site",
        disabled: _ctx.submittingSupportRequest || !_ctx.isUserLoggedIn,
        label: _ctx.$t(`supportRequest.siteInputLabel`),
        value: _ctx.request.site,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.request.site) = $event)),
        readonly: _ctx.isUserLoggedIn && _ctx.readonly.site
      }, null, 8, ["disabled", "label", "value", "readonly"]),
      _createVNode(_component_imdex_text_field, {
        style: {"margin-bottom":"15px"},
        ref: "subject",
        disabled: _ctx.submittingSupportRequest,
        label: _ctx.$t(`supportRequest.subjectInputLabel`),
        value: _ctx.request.subject,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.request.subject) = $event))
      }, null, 8, ["disabled", "label", "value"]),
      _createVNode(_component_imdex_textarea, {
        ref: "message",
        disabled: _ctx.submittingSupportRequest,
        label: _ctx.$t(`supportRequest.messageInputLabel`),
        value: _ctx.request.message,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.request.message) = $event))
      }, null, 8, ["disabled", "label", "value"]),
      (_ctx.submitError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.submitErrorMessage), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_imdex_btn, {
        disabled: _ctx.submittingSupportRequest,
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`supportRequest.closeBtn`)), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_imdex_btn, {
        secondary: "",
        onClick: _ctx.submitSupportRequest,
        loading: _ctx.submittingSupportRequest
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`supportRequest.submitBtn`)), 1)
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ])
  ]))
}